import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Flex, Header, Text } from "@fluentui/react-northstar";
import styles from "./errorContent.module.scss";
import { ReactComponent as MsTeamsError } from "shared/svgs/MsTeamsErrorStorybook.svg";

export interface ErrorContentProps {
    title: string | undefined;
    message?: string | undefined;
}

const ErrorContent: React.FC<ErrorContentProps> = observer((props)  => {

    return (
        <Flex className={styles.wrapper} hAlign="center" vAlign="center" column>
            <div className={styles.svg}>
                <MsTeamsError />
            </div>
            <Header as="h2" content={props.title} align="center" />
            <Text align="center">{props.message}</Text>
        </Flex>
    )
});

export default ErrorContent;